module.exports = __webpack_public_path__ + "static/img/buttonTwo.e13dbf7a.png";